import React from 'react';
import {Link} from 'react-router';
import img from '../style/imgs/banner.png';
import {APP_TITLE, EMAIL_SERVER} from '../constants/configValues'
class RegisterSuccess extends React.Component {
  render() {
    const {params} = this.props
    return (<div className="login">
      <div className="login-form">
        <img src={img} alt="banner" className="banner"/>
        <div className="title">{APP_TITLE}</div>
        <p className="message">Email
          <a role="button">{params.email}</a>
          đã đăng kí thành công! Để kích hoạt tài khoản hãy làm theo hướng dẫn trong email được gửi từ địa chỉ
          <a role="button">{EMAIL_SERVER}</a>.</p>
        <div>
          <Link to='/login'>Đăng nhập</Link>
        </div>
      </div>
    </div>)
  }
}

export default RegisterSuccess;



// WEBPACK FOOTER //
// ./src/pages/RegisterSuccess.js